<template>
<div>
    <kt-row>
        <kt-col lg="12" md="12" xs="12">
            <kt-col lg="12" class="text-center py-2 bg-dark" >
                <div>
                    <h5 class="font-weight-bold text-white">
                        {{ $t('bill-service.page_title') }}
                    </h5>
                </div>
            </kt-col>
        </kt-col>
        <kt-col lg="12" md="12" xs="12" class="mt-md-3 mt-5">
            <kt-row>
                <kt-col lg="2" md="4"></kt-col>
                <kt-col lg="8" md="4" class="bg-white border-rounded rounded-3 shadow">
                    <kt-row>
                        <kt-col lg="5" md="4" xs="4">
                        </kt-col>
                        <kt-col lg="2" md="4" xs="4" class="mt-2 my-1">
                            <div class="text-center py-3">
                                <img src="../../src/views/pardakhtShakhsi/assets/ps-logo.jpg" class="img-thumbnail border-0">
                            </div>
                        </kt-col>
                    </kt-row>
                </kt-col>
                <kt-col lg="2" md="4"></kt-col>
            </kt-row>
        </kt-col>
        <kt-col lg="12" md="12" xs="12">
            <kt-row style="margin-top: 1px">
                <kt-col lg="2"></kt-col>
                <kt-col lg="8" class="bg-white h-100 pb-5 border-rounded rounded-3 shadow">
                    <kt-col lg="12" class="title mt-md-1">
                        <div>
                            <h3 class="font-weight-bold">
                                {{ $t('bill-service.bill_payment') }}
                            </h3>
                            <h6>
                                {{ $t('bill-service.text_payment') }}
                            </h6>
                        </div>
                    </kt-col>
                </kt-col>
                <kt-col lg="2"></kt-col>
            </kt-row>
        </kt-col>
        <kt-col lg="12" md="3" xs="12">
            <kt-row style="margin-top: 1px" class="text-center">
                <kt-col lg="2">
                </kt-col>
                <kt-col lg="8" class="bg-white border-rounded rounded-3 shadow">
                    <kt-row class="mt-2">
                        <kt-col lg="3" md="3" xs="12">
                            <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                              <a class="nav-link active font-weight-bold" id="inquiry_bill_button"
                                 data-toggle="tab" href="#inquiry_bill_list" aria-selected="false"
                              >
                                {{ $t('bill-service.inquiry_bill') }}
                              </a>
                              <a class="nav-link font-weight-bold" data-toggle="tab" id="pay_bill_button" href="#pay_bill_list" aria-selected="false">
                                {{ $t('bill-service.bill_payment') }}
                              </a>
                            </div>
                        </kt-col>
                        <kt-col lg="9" md="9" xs="12">
                          <div class="tab-content" id="v-pills-tabContent">
                            <div class="tab-pane fade show active" id="inquiry_bill_list" role="tabpanel" aria-labelledby="v-pills-home-tab">
                              <form @submit.prevent = "inquiryBill($event, query)">
                                <kt-row>
                                  <kt-col lg="12">
                                    <kt-row v-if="show_result">
                                      <kt-col lg="12" class=" my-2 font-weight-bold">
                                        <h5 class="font-weight-bold text-right">
                                          {{ $t('bill-service.show_result') }}
                                        </h5>
                                      </kt-col>
                                      <kt-col lg="12">
                                        <kt-col lg="6" style="background-color:#00c1a4;height: 1px" >
                                        </kt-col>
                                      </kt-col>
                                      <kt-col lg="12" class="py-1">
                                        <kt-row>
                                          <kt-col lg="6" md="6" xs="12" class="mt-md-2 py-1">
                                            <div class="font-weight-bold text-center py-2 mt-2 border border-success rounded-pill">
                                              {{ $t('bill-service.bill_id') }}
                                              {{result.bill_id}}
                                            </div>
                                            <div class="font-weight-bold text-center py-2 mt-2 border border-success rounded-pill">
                                              {{ $t('bill-service.pay_id') }}
                                              {{result.pay_id}}
                                            </div>
                                          </kt-col>
                                          <kt-col lg="6" md="6" xs="12" class="mt-2 py-1">
                                            <div class="font-weight-bold text-center py-2 mt-2 border border-success rounded-pill">
                                              {{ $t('bill-service.amount_bill') }}
                                              {{result.bill_amount}}
                                            </div>
                                          </kt-col>
                                        </kt-row>
                                      </kt-col>
                                      <kt-col lg="12" md="12" xs="12" class="py-1">
                                          <button
                                              class="btn btn-wide w-100 border-0 rounded-pill font-weight-bold shadow py-2"
                                              size="md"
                                              type="button"
                                              id="payBill"
                                              @click="payBill($event, query)"
                                              style="background-color: #00c1a4!important;"
                                          >
                                            {{ $t('bill-service.pay_bill') }}
                                          </button>
                                      </kt-col>
                                      <kt-col lg="12" class="py-1">
                                          <button
                                              class="btn btn-wide w-100 border-0 rounded-pill font-weight-bold shadow py-2"
                                              size="md"
                                              type="button"
                                              id="inquiry_bill"
                                              @click="show_pay_bill_direct($event, query)"
                                              style="background-color: #00c1a4!important;"
                                          >
                                            {{ $t('bill-service.inquiry_bill') }}
                                          </button>
                                      </kt-col>
                                    </kt-row>
                                    <kt-row v-else>
                                      <kt-col lg="12" class=" my-2 font-weight-bold">
                                        <h5 class="font-weight-bold text-right">
                                          {{ $t('bill-service.info_bill') }}
                                        </h5>
                                      </kt-col>
                                      <kt-col lg="12">
                                        <kt-col lg="6" style="background-color:#00c1a4;height: 1px" >
                                        </kt-col>
                                      </kt-col>
                                      <kt-col lg="12"></kt-col>
                                      <kt-col lg="6" class="py-1">
                                        <kt-col lg="12"  class="mt-2 py-1">
                                          <h5 class="font-weight-bold text-right">
                                            {{ $t('bill-service.type_bill') }}
                                          </h5>
                                          <select id="type_bill"
                                                  name="type_bill"
                                                  class="form-control kt-selectpicker"
                                                  v-model="query.bill_type">
                                            <option value="Tel" selected>
                                              {{ $t('bill-service.bill_tel') }}
                                            </option>
                                            <option value="Gas">
                                              {{ $t('bill-service.bill_gas') }}
                                            </option>
                                            <option value="Electricity">
                                              {{ $t('bill-service.bill_electricity') }}
                                            </option>
                                            <option value="Water">
                                              {{ $t('bill-service.bill_water') }}
                                            </option>
                                            <option value="Mobile">
                                              {{ $t('bill-service.bill_mobile') }}
                                            </option>
                                          </select>
                                        </kt-col>
                                      </kt-col>
                                      <kt-col lg="6" class="py-1">
                                        <kt-col lg="12"  class="mt-2 py-1">
                                          <h5 class="font-weight-bold text-right" v-if = "query.bill_type === 'Tel'">
                                            {{ $t('bill-service.tel') }}
                                          </h5>
                                          <h5 class="font-weight-bold text-right" v-else-if = "query.bill_type === 'Mobile'">
                                            {{ $t('bill-service.mobile') }}
                                          </h5>
                                          <h5 class="font-weight-bold text-right" v-else>
                                            {{ $t('bill-service.bill_id') }}
                                          </h5>
                                          <kt-form-group>
                                            <kt-form-control
                                                ref="billID"
                                                name="billID"
                                                id="billID"
                                                v-model="query.bill_id"
                                                dir="ltr"
                                            />
                                          </kt-form-group>
                                        </kt-col>
                                      </kt-col>
                                      <kt-col lg="12" class="py-1">
                                        <button
                                            class="btn btn-wide w-100 border-0 rounded-pill font-weight-bold shadow py-2"
                                            size="md"
                                            type="submit"
                                            id="inquiryBill"
                                            style="background-color: #00c1a4!important;"

                                        >
                                          {{ $t('bill-service.inquiry_bottun') }}
                                        </button>
                                      </kt-col>
                                      <kt-col lg="12" class="mt-1" style="text-align: center !important;">
                                        <kt-row>
                                          <kt-col lg="12" class="mt-1">

                                          </kt-col>
                                        </kt-row>
                                      </kt-col>
                                    </kt-row>
                                  </kt-col>
                                </kt-row>
                              </form>
                            </div>
                            <div class="tab-pane fade" id="pay_bill_list" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                              <kt-row>
                                <kt-col lg="12">
                                  <kt-row>
                                    <kt-col lg="12" class=" my-2 font-weight-bold">
                                      <h5 class="font-weight-bold text-right">
                                        {{ $t('bill-service.info_bill') }}
                                      </h5>
                                    </kt-col>
                                    <kt-col lg="12">
                                      <kt-col lg="6" style="background-color:#00c1a4;height: 1px" >
                                      </kt-col>
                                    </kt-col>
                                    <kt-col lg="12"></kt-col>
                                    <kt-col lg="12" class=" py-1 mt-2">
                                      <kt-row>
                                        <kt-col lg="6" md="6" xs="6">
                                          <h5 class="font-weight-bold text-right">
                                            {{ $t('bill-service.type_bill') }}
                                          </h5>
                                          <select id="type_bill_direct"
                                                  name="type_bill_direct"
                                                  class="form-control kt-selectpicker"
                                                  v-model="query.bill_type_direct">
                                            <option value="Tel" selected>
                                              {{ $t('bill-service.bill_tel') }}
                                            </option>
                                            <option value="Gas">
                                              {{ $t('bill-service.bill_gas') }}
                                            </option>
                                            <option value="Electricity">
                                              {{ $t('bill-service.bill_electricity') }}
                                            </option>
                                            <option value="Water">
                                              {{ $t('bill-service.bill_water') }}
                                            </option>
                                            <option value="Mobile">
                                              {{ $t('bill-service.bill_mobile') }}
                                            </option>
                                          </select>
                                        </kt-col>
                                        <kt-col  lg="6" md="6" xs="6">
                                          <h5 class="font-weight-bold text-right" v-if = "query.bill_type_direct === 'Tel'">
                                            {{ $t('bill-service.tel') }}
                                          </h5>
                                          <h5 class="font-weight-bold text-right" v-else-if = "query.bill_type_direct === 'Mobile'">
                                            {{ $t('bill-service.mobile') }}
                                          </h5>
                                          <kt-form-group v-if="query.bill_type_direct === 'Tel'||query.bill_type_direct === 'Mobile'">
                                            <kt-form-control
                                                ref="billID"
                                                name="billID"
                                                id="billID"
                                                v-model="query.bill_id_for_mob_tel"
                                                dir="ltr"
                                            />
                                          </kt-form-group>
                                        </kt-col>
                                      </kt-row>
                                    </kt-col>
                                    <kt-col lg="12" class="py-1">
                                      <kt-row>
                                        <kt-col lg="4" md="4" xs="12" class="mt-2 py-1">
                                          <h5 class="font-weight-bold text-right">
                                            {{ $t('bill-service.bill_id') }}
                                          </h5>
                                          <kt-form-control
                                              ref="billID"
                                              name="billID"
                                              id="billID"
                                              v-model="query.bill_id_direct"
                                              dir="ltr"
                                          />
                                        </kt-col>
                                        <kt-col lg="4" md="4" xs="12" class="mt-2 py-1">
                                          <h5 class="font-weight-bold text-right">
                                            {{ $t('bill-service.pay_id') }}
                                          </h5>
                                          <kt-form-control
                                              ref="pay_id_direct"
                                              name="pay_id_direct"
                                              id="pay_id_direct"
                                              v-model="query.pay_id_direct"
                                              dir="ltr"
                                          />
                                        </kt-col>
                                        <kt-col lg="4" md="4" xs="12" class="mt-2 py-1">
                                          <h5 class="font-weight-bold text-right">
                                            {{ $t('bill-service.amount_bill') }}
                                          </h5>
                                          <kt-form-control
                                              ref="billID"
                                              name="billID"
                                              id="billID"
                                              v-model="query.bill_amount_direct"
                                              dir="ltr"
                                          />
                                        </kt-col>
                                      </kt-row>
                                    </kt-col>
                                    <kt-col lg="12" class="py-1">
                                        <button
                                            class="btn btn-wide w-100 border-0 rounded-pill font-weight-bold shadow py-2"
                                            size="md"
                                            type="button"
                                            id="pay_bill"
                                            style="background-color: #00c1a4"
                                            @click="pay_bill_direction($event, query)"
                                        >
                                          {{ $t('bill-service.pay') }}
                                        </button>
                                    </kt-col>
                                  </kt-row>
                                </kt-col>
                              </kt-row>
                            </div>
                          </div>
                        </kt-col>
                    </kt-row>
                </kt-col>
                <kt-col lg="2">

                </kt-col>
            </kt-row>
        </kt-col>
        <kt-col lg="12" md="12" xs="12">
            <kt-row style="margin-top: 1px">
                <kt-col lg="2">
                </kt-col>
                <kt-col lg="8" class="bg-white pb-5 border-rounded shadow">
                    <kt-col lg="12" class="title mt-md-1 pb-3">
                        <div>
                            <h5 class="font-weight-bold">
                                {{ $t('bill-service.help') }}
                            </h5>
                            <h6 class="font-weight-bold">
                                {{ $t('bill-service.help_text') }}
                            </h6>
                        </div>
                    </kt-col>
                </kt-col>
                <kt-col lg="2"></kt-col>
            </kt-row>
        </kt-col>
    </kt-row>
</div>
</template>

<script>


import $ from 'jquery'
import { ApiUrl } from '@/common/api.service'
import axios from "axios";
import { KTApp } from '@/plugins/core/app'
import { i18n } from '@/plugins/i18n'
// import Bill from  '../assets/media/bill.jpg'
import toastr from 'toastr'


export default {

    name: "Billservices" ,

    data() {
        return {
            result: {},
            query: {
                bill_type : null
            },
            show_result : false,
            // image : Logo ,
            // image_ : Bill,
            bill_id_correct : {}
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    methods: {
        inquiryBill(e, query){
            let btn = $('#inquiryBill')
            KTApp.progress(btn)
            axios({
                url: ApiUrl.path(`bill-services/inquiry`),
                method: 'POST',
                params: {
                    'bill_id'          : query.bill_id,
                    'bill_type'        : query.bill_type
                }
            }).then((response) => {
                KTApp.unprogress(btn);
                if (response.data.data == '') {
                    this.toastr.error(response.data.message)
                } else {
                    this.toastr.success(response.data.message)
                    this.result = response.data.data.data
                    this.show_result =true
                }
            }).catch(({response}) => {
                this.toastr.error(response.data.message)
                KTApp.unprogress(btn)
            }) .finally(() => {
                KTApp.unprogress(btn)
            })
        },
        pay_bill_direction(e, query){
            let btn = $('#payBill')
            KTApp.progress(btn)
            if (query.bill_id_for_mob_tel) {
               this.bill_id_correct = query.bill_id_for_mob_tel
            } else {
                this.bill_id_correct = query.bill_id_direct
            }
            axios({
                url: ApiUrl.path(`bill-services/inquiry`),
                method: 'POST',
                params: {
                    'bill_id'          : this.bill_id_correct,
                    'bill_type'        : query.bill_type_direct
                },
            }).then((response) => {
                KTApp.unprogress(btn);
                if (response.data.data == '') {
                    this.toastr.error(response.data.message)
                } else {
                  this.result = response.data.data.data
                }
                    // if (this.result.bill_id == query.bill_id_direct || this.result.pay_id == query.pay_id_direct
                //     || this.result.bill_amount == query.bill_amount_direct){
                        axios({
                            url: ApiUrl.path(`bill-services/pay`),
                            method: 'POST',
                            params: {
                                'bill_id'          : this.result.bill_id,
                                'pay_id'           : this.result.pay_id,
                                'bill_amount'      : this.result.bill_amount,
                                'bill_type'        : query.bill_type_direct
                            },
                        }).then((response) => {
                            KTApp.unprogress(btn);
                            window.location.href = response.data
                        }).catch(({response}) => {
                            KTApp.unprogress(btn)
                        }) .finally(() => {
                            KTApp.unprogress(btn)
                        })
                    // } else {
                    //     this.toastr.error(i18n.t('message.an_error_accord'))
                    // }
                // }
            }).catch(({response}) => {
                this.toastr.error(response.data.message)
                KTApp.unprogress(btn)
            }) .finally(() => {
                KTApp.unprogress(btn)
            })
        },
        payBill(e, query){
            let btn = $('#payBill')
            KTApp.progress(btn)
            this.query = query
            axios({
                url: ApiUrl.path(`bill-services/pay`),
                method: 'POST',
                params: {
                    'bill_id'     : this.result.bill_id,
                    'pay_id'      : this.result.pay_id,
                    'bill_amount' : this.result.bill_amount,
                    'bill_type'   : query.bill_type
                },
            }).then((response) => {
                KTApp.unprogress(btn);
                window.location.href = response.data
            }).catch(({response}) => {
                KTApp.unprogress(btn)
            }) .finally(() => {
                KTApp.unprogress(btn)
            })
        },
        payMobile(e, query){
            let btn = $('#payBill')
            KTApp.progress(btn)
            this.query = query
            axios({
                url: ApiUrl.path(`bill-services/charge`),
                method: 'POST',
                params: {
                    'mobile'   : query.phone_number,
                    'price'    : query.amount_charge,
                    'operator' : query.operator,
                },
            }).then((response) => {
                KTApp.unprogress(btn);
                window.location.href = response.data
            }).catch(({response}) => {
                KTApp.unprogress(btn)
            }) .finally(() => {
                KTApp.unprogress(btn)
            })
        },
        show_pay_bill_direct (e, query) {
            this.show_result = false
        },
    },
}
</script>
<style scoped>
.title {
    border-right: 3px solid #00c1a4;
    border-bottom: none;
}
a.nav-link.active {
    background-color: #00c1a4 !important;
    color: #0f0f16 !important;
}
</style>